import template from './employee_documents_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class EmployeeDocumentsHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class EmployeeDocumentsHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeeDocumentsHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'EmployeeDocumentsHelp',
	dialog_class: EmployeeDocumentsHelpPage,
	template: template,
	template_filename: 'translation/dialogs/employee_documents_help',
	provider: 'ps'
};
